import type { LinkOptions } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import React from "react";
import { useStore } from "@/store";

export const AppLink: React.FC<
  PropsWithChildren<
    React.AnchorHTMLAttributes<HTMLAnchorElement> &
      Omit<LinkOptions, "state"> & { state?: any }
  >
> = ({ children, ...linkProps }) => {
  const { activeProvinceId } = useStore();

  return (
    <Link
      search={{
        province: linkProps.to === "/" ? undefined : activeProvinceId,
      }}
      {...linkProps}
    >
      {children}
    </Link>
  );
};
